import { render, staticRenderFns } from "./TaskModule.vue?vue&type=template&id=15cd8144&scoped=true&"
import script from "./TaskModule.vue?vue&type=script&lang=js&"
export * from "./TaskModule.vue?vue&type=script&lang=js&"
import style0 from "./TaskModule.vue?vue&type=style&index=0&id=15cd8144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd8144",
  null
  
)

export default component.exports